import Vue from 'vue'
import Login from './src/main.vue'

Login.install = (options) => {
  if (document.querySelector('#login_panel')) {
    return
  }
  const Logins = Vue.extend(Login)
  const component = new Logins().$mount()
  document.querySelector('body').appendChild(component.$el)
}

export default Login



// WEBPACK FOOTER //
// ./src/plugin/login-register/index.js